const RealEstate = () => (
    <div className="page-content">
        <h1>Patrimoine</h1>
        <p>Bienvenue sur la page Patrimoine.</p>
    </div>
);

export default RealEstate;